import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "auth-form-container" }
const _hoisted_2 = { class: "auth-card" }
const _hoisted_3 = { class: "auth-header" }
const _hoisted_4 = { class: "auth-title" }
const _hoisted_5 = { class: "captcha-input-group" }
const _hoisted_6 = { class: "form-actions" }
const _hoisted_7 = { class: "auth-helper-links" }
const _hoisted_8 = { class: "captcha-input-group" }
const _hoisted_9 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[16] || (_cache[16] = _createElementVNode("div", { class: "bg-glow-sphere glow-1" }, null, -1)),
      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "bg-glow-sphere glow-2" }, null, -1)),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.isLogin ? _ctx.$t("login.title") : _ctx.$t("register.title")), 1),
          _cache[15] || (_cache[15] = _createElementVNode("p", { class: "auth-subtitle" }, "BAGL Creator Studio · 创作者中枢", -1))
        ]),
        _createVNode(_component_el_form, {
          ref: "authFormRef",
          model: _ctx.authForm,
          rules: _ctx.formRules,
          "label-position": "top",
          onSubmit: _withModifiers(_ctx.handleSubmit, ["prevent"]),
          class: "modern-form"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('login.username'),
              prop: "username"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.authForm.username,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.authForm.username) = $event)),
                  placeholder: 
              !_ctx.isLogin ? _ctx.$t('login.usernamePlaceholder') : '请输入用户名 / 账号'
            ,
                  size: "large",
                  clearable: "",
                  "prefix-icon": _ctx.User
                }, null, 8, ["modelValue", "placeholder", "prefix-icon"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('login.password'),
              prop: "password"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.authForm.password,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.authForm.password) = $event)),
                  type: "password",
                  placeholder: 
              !_ctx.isLogin ? _ctx.$t('login.passwordPlaceholder') : '请输入密码'
            ,
                  "show-password": "",
                  size: "large",
                  "prefix-icon": _ctx.Lock
                }, null, 8, ["modelValue", "placeholder", "prefix-icon"])
              ]),
              _: 1
            }, 8, ["label"]),
            (!_ctx.isLogin)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_el_form_item, {
                    label: "确认登录密码",
                    prop: "confirmPassword"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.authForm.confirmPassword,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.authForm.confirmPassword) = $event)),
                        type: "password",
                        placeholder: "请再次输入相同密码",
                        "show-password": "",
                        size: "large",
                        "prefix-icon": _ctx.CircleCheck
                      }, null, 8, ["modelValue", "prefix-icon"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "绑定邮箱",
                    prop: "email"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.authForm.email,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.authForm.email) = $event)),
                          placeholder: "请输入有效电子邮箱",
                          size: "large",
                          "prefix-icon": _ctx.Message
                        }, null, 8, ["modelValue", "prefix-icon"]),
                        _createVNode(_component_el_button, {
                          type: "primary",
                          plain: "",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sendCaptcha(1))),
                          disabled: _ctx.isCountdown,
                          class: "captcha-btn",
                          size: "large"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.countdown > 0 ? `${_ctx.countdown}s` : "获取验证码"), 1)
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "邮箱验证码",
                    prop: "captcha"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.authForm.captcha,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.authForm.captcha) = $event)),
                        placeholder: "请输入 6 位验证码",
                        size: "large",
                        maxlength: "6",
                        "prefix-icon": _ctx.Key
                      }, null, 8, ["modelValue", "prefix-icon"])
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_el_button, {
                type: "primary",
                "native-type": "submit",
                size: "large",
                loading: _ctx.submitting,
                class: "submit-btn"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.isLogin ? _ctx.$t("login.submit") : _ctx.$t("register.submit")), 1)
                ]),
                _: 1
              }, 8, ["loading"])
            ])
          ]),
          _: 1
        }, 8, ["model", "rules", "onSubmit"]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", {
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.toggleAuthMode && _ctx.toggleAuthMode(...args))),
            class: "helper-link"
          }, _toDisplayString(_ctx.isLogin ? _ctx.$t("register.switch") : _ctx.$t("login.switch")), 1),
          _createVNode(_component_el_divider, { direction: "vertical" }),
          _createElementVNode("span", {
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.showPage && _ctx.showPage(...args))),
            class: "helper-link text-muted"
          }, "忘记密码?")
        ])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.centerDialogVisible,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.centerDialogVisible) = $event)),
      title: "找回与重置密码",
      width: "480px",
      "destroy-on-close": "",
      "align-center": "",
      class: "forgot-password-dialog"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_el_button, {
            size: "large",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.centerDialogVisible = false)),
            class: "cancel-btn"
          }, {
            default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
              _createTextVNode("取消", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            size: "large",
            loading: _ctx.resetting,
            onClick: _ctx.editPassword,
            class: "confirm-btn"
          }, {
            default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
              _createTextVNode(" 确认重置密码 ", -1)
            ]))]),
            _: 1
          }, 8, ["loading", "onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "forgotFormRef",
          model: _ctx.form,
          rules: _ctx.forgotRules,
          "label-position": "top",
          class: "dialog-inner-form"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "密保邮箱",
              prop: "email"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.email,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.email) = $event)),
                  placeholder: "请输入绑定的注册邮箱",
                  size: "large",
                  "prefix-icon": _ctx.Message
                }, null, 8, ["modelValue", "prefix-icon"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "安全验证码",
              prop: "code"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.code,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.code) = $event)),
                    placeholder: "输入 6 位数字",
                    size: "large",
                    "prefix-icon": _ctx.Key
                  }, null, 8, ["modelValue", "prefix-icon"]),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    plain: "",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.sendCaptcha(2))),
                    disabled: _ctx.isCountdown2,
                    class: "captcha-btn",
                    size: "large"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.countdown2 > 0 ? `${_ctx.countdown2}s` : "获取验证码"), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "设置新密码",
              prop: "password"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.password,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.password) = $event)),
                  type: "password",
                  "show-password": "",
                  placeholder: "输入新密码 (6 位以上字符)",
                  size: "large",
                  "prefix-icon": _ctx.Lock
                }, null, 8, ["modelValue", "prefix-icon"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "确认新密码",
              prop: "confirmPassword"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.confirmPassword,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.confirmPassword) = $event)),
                  type: "password",
                  "show-password": "",
                  placeholder: "请再次确认新密码",
                  size: "large",
                  "prefix-icon": _ctx.CircleCheck
                }, null, 8, ["modelValue", "prefix-icon"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}